module.exports = require('date-fns/isSameDay').isSameDay;
